export const LIST = "LIST";
export const SETTING_DATA = "SETTING_DATA";
export const CREATE = "CREATE";
export const UPDATE = "UPDATE";